export default __webpack_public_path__ + "static/media/FlyingFrog20.a6f79e98.png";